import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { get } from 'lodash';

import EmbeddedIFrame from 'components/atoms/EmbeddedIFrame';
import LayerThreeDashboardComponent from 'containers/dashboards/DashboardBaseComponent';
import { fetchMeta as fetchEntityMeta } from 'services/entities/duck';
import { fetchEmbeddedLink, fetchRedashLinkProxy } from 'services/embeddedLinks/duck';

/**
 * For local testing, sample iframes
 * GDS - https://datastudio.google.com/embed/reporting/c97a01b0-25f6-4a87-ab8f-c23434a72aee/page/hiJYB
 * Redash no params - https://gw-data.goodwaygroup.com/public/dashboards/w7ZYW1dPBMNwRxRR8BB5KcCz5VoMMW2D2etImHHD?org_slug=default
 * Redash with params - https://gw-data.staging.goodwaygroup.com/public/dashboards/MQ7kZc5KNPypE4TOk9G5zSrzQXJUwaVBxmkvGdcX?org_slug=default
 */
class Dashboard extends LayerThreeDashboardComponent {
    constructor(props) {
        super(props, 'embedded');
    }

    fetchFrameUrl() {
        const entityId = this.getCurrentEntityId();
        const { slug, embeddedLinks } = this.props;
        const [selectedLink] = embeddedLinks.filter(link => link.slug === slug);

        if (selectedLink) {
            if (selectedLink.platform === 'redash') {
                this.props.fetchRedashLinkProxy({ entityId, slug });
            } else {
                this.props.fetchEmbeddedLink({ entityId, slug });
            }
        }
    }

    componentDidMount() {
        this.makeRequestsForData();
    }

    componentDidUpdate(prevProps, prevState) {
        const isEntityChanged = prevState.entityId !== this.getCurrentEntityId();
        if (isEntityChanged) {
            this.makeRequestsForData();
        }

        // Triggers when navigating from custom dashboard to custom dashboard
        if (this.props.slug !== prevProps.slug) {
            this.fetchFrameUrl();
        }

        // Makes sure to fire the fetch for the first time after the meta call returns
        if (this.props.embeddedLinks !== prevProps.embeddedLinks) {
            this.fetchFrameUrl();
        }
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const channel = this.getCurrentChannel();
        const payload = this.createPayload(entityId, channel);

        if (this.props.entities.meta.id !== entityId) {
            this.props.fetchEntityMeta(payload);
        }

        // TODO: can probably? get rid of this since I don't think it can ever return anything useful
        // before embeddedLinks shows up (see componentDidUpdate)
        this.fetchFrameUrl();
    }

    render() {
        const { frameUrl } = this.props;

        // TODO: add a loading state/div to flash before frameUrl populates
        return frameUrl ? (
            <EmbeddedIFrame
                src={frameUrl}
                width="100%"
            />
        ) : (
            <Grid>
                No custom channel embed link set
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    theme: state.theme,
    entities: state.entities,
    entityMeta: state.entities.meta,
    selectedTimeRange: state.config.selectedTimeRange,
    embeddedLinks: get(state, 'entities.meta.embeddedLinks', []),
    frameUrl: get(state, 'embeddedLinks.embeddedLink.frameUrl'),
});

export default connect(mapStateToProps, {
    fetchEntityMeta,
    fetchEmbeddedLink,
    fetchRedashLinkProxy
})(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/dashboards/LayerThreeEmbeddedContainer.js